// Public YouTube metadata that the browser can fetch directly (CORS-enabled oEmbed).
// Used only to show title/channel immediately; the server's `meta` event wins.

import type { VideoMeta } from '../../shared/api';
import { youTubeWatchUrl } from '../../shared/youtube-url';

export async function fetchYouTubeOEmbed(videoId: string, timeoutMs = 6000): Promise<Partial<VideoMeta> | null> {
  const url = `https://www.youtube.com/oembed?format=json&url=${encodeURIComponent(youTubeWatchUrl(videoId))}`;
  try {
    const res = await fetch(url, {
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
      signal: AbortSignal.timeout(timeoutMs),
    });
    if (!res.ok) return null;
    const body = (await res.json()) as { title?: unknown; author_name?: unknown; author_url?: unknown };
    if (typeof body.title !== 'string' || !body.title) return null;
    return {
      videoId,
      title: body.title,
      ...(typeof body.author_name === 'string' ? { channel: body.author_name } : {}),
      ...(typeof body.author_url === 'string' ? { channelUrl: body.author_url } : {}),
    };
  } catch {
    return null;
  }
}
